export default __webpack_public_path__ + "static/GmarketSansMedium-3b975ddd58dcbe363ee5d8006bca4325.otf";